import Repository from "./Repository";

const CREATE = "/add";
const DELETE = "/delete";
const EDIT = "/edit";
const SENT_EMAIL = "email/sent";
const GET_ALL = "";
const GENERATE_EMPLOYEE = "/generateEmployee";

export default {
  create(payload) {
    return Repository.post(transformRoute(CREATE), payload);
  },
  delete(payload) {
    return Repository.post(transformRoute(DELETE), payload);
  },
  edit(payload) {
    return Repository.post(transformRoute(EDIT), payload);
  },
  get_all(payload) {
    return Repository.get(transformRoute(GET_ALL));
  },
  sent_email(payload) {
    return Repository.post(transformRoute(SENT_EMAIL), payload);
  },
  generateEmployee(payload) {
    return Repository.post(transformRoute(GENERATE_EMPLOYEE), payload);
  },
};
const transformRoute = (route) => {
  return `companydash${route}`;
};
